module.exports = __webpack_public_path__ + "static/media/MetaMask_Fox.d206794f.svg";